import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MobileStreamService {

  constructor(private rest: RestService) { }

  /** Hub: `{}`. Local mobile: `{ localExecutionUrls: ["host"] }` */
  getMobileExecutionList(body?: { localExecutionUrls?: string[] }) {
    let payload: any = {};
    if (body && body.localExecutionUrls && body.localExecutionUrls.length > 0) {
      payload = { localExecutionUrls: body.localExecutionUrls };
    }
    return this.rest.post('getDeviceDetails', payload, null).pipe(
      map((res: any) => {
        if (res && Array.isArray(res.data)) {
          res.data = res.data.map((item: any) => ({
            ...item,
            platform: item.platform ? item.platform.toString().toUpperCase() : item.platform,
            status: item.status ? item.status.toString().toUpperCase() : item.status,
          }));
        }
        return res;
      })
    );
  }

  getEmulatorsStatus(emulatorIDs: string[]) {
    const payload = { emulators: emulatorIDs };
    return this.rest.post('getEmulatorsStatus', payload, null).pipe(
      map((res: any) => {
        if (res && res.data && typeof res.data === 'object' && !Array.isArray(res.data)) {
          const normalized: { [id: string]: any } = {};
          Object.keys(res.data).forEach(key => {
            const val = res.data[key];
            if (val && typeof val === 'object') {
              normalized[key] = {
                ...val,
                status: val.status != null ? String(val.status).toUpperCase() : val.status
              };
            } else if (typeof val === 'string') {
              normalized[key] = { status: val.toUpperCase() };
            } else {
              normalized[key] = val;
            }
          });
          res.data = normalized;
        }
        return res;
      })
    );
  }

}
